<template>
<!-- 商品入库 -->
	<content-view>
		<div class="materiel-add">
			<a-form :form="form" :selfUpdate="true">
				<a-spin :spinning="spinning">
                    <a-form-item label="扫描录入商品条形码" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
                        <a-input style="width: 90%;" v-decorator="['goodsBarCode', {rules: [{max: 30, message: '不能超过30个字'}, {whitespace: true, message: '商品条形码不能为空字符'}]}]" placeholder="请录入"/>
                    </a-form-item>
                    <a-form-item label="商品名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
                        <a-input style="width: 90%;" @blur="() => {}" v-decorator="['goodsName', {rules: [{ required: true, message: '请输入商品名称' }, {max: 50, message: '不能超过50个字'}, {whitespace: true, message: '商品名称不能为空字符'}]}]" placeholder="请输入"/>
                    </a-form-item>
                    <a-form-item label="商品规格" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
                        <a-input style="width: 90%;" v-decorator="['goodsSpecification', {rules: [{ required: true, message: '请选择商品规格'}, {max: 20, message: '不能超过20个字'}, {whitespace: true, message: '商品规格不能为空字符'}]}]" placeholder="请输入"/>
                    </a-form-item>
                    <a-form-item label="基本单位" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }" style="position:relative">
                        <a-select style="width: 90%;" :options="goodsUnitList" v-decorator="['goodsUnitId', {rules: [{ required: true, message: '请选择单位' }]}]" placeholder="请选择"></a-select>
                        <a class="ml8 text-primary" @click="addUnitVisible = true">新增单位</a>
                    </a-form-item>
                    <a-form-item label="商品分组" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }" style="position:relative">
                        <a-select style="width: 90%;" :options="typeOptions" v-decorator="['goodsCategoryId', {rules: [{ required: true, message: '请选择商品类别' }]}]" placeholder="请选择"></a-select>
                        <a class="ml8 text-primary" @click="addTypeVisible = true">新增类别</a>
                    </a-form-item>
                    <a-form-item label="使用类型" required :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
                        <a-radio-group v-decorator="['useType',{initialValue: 1}]">
                            <a-radio :value="1">售卖</a-radio>
                            <a-radio :value="2">自用</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-divider></a-divider>
                    <a-form-item label="商品成本价" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
                        <a-input-number style="width: 90%" :step="1" placeholder="请输入" v-decorator="['costPrice', {rules: [{ required: true, message: '请输入商品成本价'}, {pattern: /^([0-9]{1,}\d*[.]*\d{0,2})$|^([0]{1}[.]{1}\d{1,2})$/, message: '所填值不能小于0，且只保留两位小数'}]}]" />
                    </a-form-item>
                    <a-form-item label="商品售卖价" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
                        <a-input-number style="width: 90%" :step="1" placeholder="请输入" v-decorator="['sellPrice', {rules: [{ required: true, message: '请输入商品售卖价'}, {pattern: /^([0-9]{1,}\d*[.]*\d{0,2})$|^([0]{1}[.]{1}\d{1,2})$/, message: '所填值不能小于0，且只保留两位小数'}]}]" />
                    </a-form-item>
                    <a-divider></a-divider>
                    <template v-if="!isEdit">
                        <a-form-item label="本次入库数" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
                            <a-input-number :precision="0" style="width: 90%" :step="1" placeholder="请输入" v-decorator="['goodsNum', {rules: [{ required: true, message: '请输入本次入库数'}, {pattern: /^[1-9]{1,}\d*$/, message: '只能为正整数'}]}]" />
                        </a-form-item>
                        <a-form-item label="入库仓库" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
                            <a-select style="width: 90%" :options="wareHouseList" disabled v-decorator="['warehouseId', {rules: [{required: true, message: '请选择'}]}]"></a-select>
                        </a-form-item>
                        <a-form-item label="备注" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
                            <a-textarea style="width: 90%; resize: none;" placeholder="0/30" v-decorator="['remark', {rules: [{ required: true, message: '请输入备注' }, { max: 30, message: '字数超出' }, {whitespace: true, message: '备注不能为空字符'}]}]" />
                        </a-form-item>
                        <a-divider></a-divider>
                    </template>
                    <div class="text-center">
                        <a-button @click="$router.go(-1)">取消</a-button>
                        <a-button v-if="isEdit" type="primary" @click="editHandleSubmit" :loading="loading">确认</a-button>
                        <a-button v-else type="primary" @click="addHandleSubmit" :loading="loading">确认</a-button>
                    </div>
                </a-spin>
			</a-form>
			<a-modal
            title="新增类别"
            centered
            :maskClosable="false"
            :visible="addTypeVisible"
            :destroyOnClose="true"
            :confirmLoading="modalLoading"
            @ok="addGoodsTypes"
            @cancel="addTypeVisible=false"
            >
				<a-form :form="addTypeForm" :selfUpdate="true">
					<a-form-item class="no-margin_bottom" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" label="类别名称">
						<a-input v-decorator="['categoryName', {rules: [{ required: true, message: '请输入'}, {max: 20, message: '不能超过20个字'}, {whitespace: true, message: '类别名称不能为空字符'}]}]"/>
					</a-form-item>
				</a-form>
			</a-modal>
			<a-modal
            title="新增单位"
            centered
            :maskClosable="false"
            :visible="addUnitVisible"
            :destroyOnClose="true"
            :confirmLoading="modalLoading"
            @ok="addGoodsUnit"
            @cancel="addUnitVisible = false"
            >
                <a-form :form="addUnitForm" :selfUpdate="true">
                    <a-form-item class="no-margin_bottom" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" label="商品单位">
                        <a-input v-decorator="['goodsUnit', {rules: [{ required: true, message: '请输入'}, {max: 20, message: '不能超过20个字'}, {whitespace: true, message: '商品单位不能为空字符'}]}]" style="width: 70%" placeholder="请输入"/>
                    </a-form-item>
                </a-form>
			</a-modal>
		</div>
	</content-view>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    export default {
        name: 'materielAdd',
        components: {},
        props: {},
        data() {
            return {
                typeOptions: [],
                goodsUnitList: [],
                wareHouseList: [],
                addTypeVisible: false,
                addUnitVisible: false,
                loading: false,
                modalLoading: false,
                spinning: false
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            success() {
                this.$message.success('扫码成功，请填写商品信息');
            },
            warning() {
                this.$message.warning('扫描商品条形码');
            },
            /**
             * @addHandleSubmit 新增商品
             */
            addHandleSubmit() {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        this.loading = true
                        this.$api.newStorage.selfGoodsAdd({ 
                            body: {
                                ...values,
                                shopId: this.shopId,
                                userId: this.userInfo.id,
                                account: this.userInfo.account,
                                username: this.userInfo.name
                            }
                        }).then(res => {
                            this.$message.success('操作成功');
                            this.$router.go(-1);
                            this.loading = false;
                        }).catch(err => {
                            this.loading = false;
                        })
                    }
                });
            },
            /**
             * @editHandleSubmit 编辑商品
             */
            editHandleSubmit() {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        this.loading = true
                        this.$api.newStorage.selfGoodsEdit({ 
                            body: {
                                ...values,
                                id: this.$route.params.id,
                                shopId: this.shopId,
                                userId: this.userInfo.id,
                                account: this.userInfo.account,
                                username: this.userInfo.name
                            }
                        }).then(res => {
                            this.$message.success('操作成功');
                            this.$router.go(-1);
                            this.loading = false;
                        }).catch(err => {
                            this.loading = false;
                        })
                    }
                });
            },
            /**
             * @addGoodsUnit 新增单位
             */
            addGoodsUnit(e) {
                this.addUnitForm.validateFields((err, values) => {
                    if (!err) {
                        this.modalLoading = true;
                        this.$api.newStorage.addSelfGoodsUnit({
                            body: {
                                ...values,
                                shopId: this.shopId
                            }
                        }).then(res => {
                            this.getGoodsUnitList();
                            this.modalLoading = false;
                            this.addUnitVisible = false;
                            this.$message.success('操作成功');
                        }).catch(err => {
                            this.modalLoading = false;
                        });
                    }
                });
            },
            /**
             * @addGoodsTypes 新增类别
             */
            addGoodsTypes(e) {
                this.addTypeForm.validateFields((err, values) => {
                    if (!err) {
                        this.modalLoading = true;
                        this.$api.newStorage.addSelfGoogsCategory({
                            body: {
                                ...values,
                                shopId: this.shopId
                            }
                        }).then(res => {
                            this.getGoodsCateList();
                            this.modalLoading = false;
                            this.addTypeVisible = false;
                            this.$message.success('操作成功');
                        }).catch(err => {
                            this.modalLoading = false;
                        });;
                    }
                });
            },
            /**
             * @getGoodsCateList 获取商品类别
             */
            getGoodsCateList() {
                this.$api.newStorage.getSelfGoodsCateList({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (Boolean(res)) {
                        res.forEach(item => {
                            item.label = item.categoryName;
                            item.value = item.id;
                        });
                        this.typeOptions = res;
                    }
                });
            },
            /**
             * @getGoodsUnitList 获取单位列表
             */
            getGoodsUnitList() {
                this.$api.newStorage.getSelfGoodsUnitList({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (Boolean(res)) {
                        res.forEach(item => {
                            item.label = item.goodsUnit;
                            item.value = item.id;
                        });
                        this.goodsUnitList = res;
                    }
                });
            },
            /**
             * @getWarehouseList 获取仓库信息列表
             */
            getWarehouseList() {
                if(!this.shopId) return
                this.$api.newStorage.selfWarehousePage({
                    body: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (Boolean(res) && Boolean(res.data) && res.data.length > 0) {
                        res.data.forEach(item => {
                            item.label = item.warehouseName;
                            item.value = item.id;
                        });
                        this.wareHouseList = res.data;
                        this.getMainWarehouse();
                    }
                });
            },
            /**
             * @getMainWarehouse 获取门店对应的主仓库
             */
            getMainWarehouse() {
                if(!this.shopId) return
                this.$api.newStorage.getSelfMainWarehouse({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (res) {
                        this.form.setFieldsValue({
                            warehouseId: res.id
                        });
                    }
                });
            },
            /**
             * @getSelfGoodsDetail 获取自有物料详情
             */
            getSelfGoodsDetail() {
                if (!this.shopId) {
                    return false;
                }
                let { id } = this.$route.params;
                this.spinning = true;
                this.$api.newStorage.selfGoodsDetail({
                    query: {
                        id,
                        shopId: this.shopId
                    }
                }).then(res => {
                    this.spinning = false;
                    delete res.id;
                    delete res.goodsId;
                    delete res.goodsNo;
                    delete res.categoryName;
                    delete res.goodsUnit;
                    this.form.setFieldsValue(res);
                });
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
            this.addTypeForm = this.$form.createForm(this);
            this.addUnitForm = this.$form.createForm(this);
            this.isEdit = Boolean(this.$route.params.id);
            this.userInfo = this.$userInfoTool.getUser();
        },
        created() {},
        mounted() {
            this.warning();
            this.getGoodsCateList();
            this.getGoodsUnitList();
            if (this.isEdit) {
                this.getSelfGoodsDetail();
                return false;
            }
            this.getWarehouseList();
        },
        watch: {
            'shopId'() {
                this.$router.back();
            }
        }
    };
</script>
<style lang="scss">
	.materiel-add {
		background-color: #fff;
		padding: 24px 32px;
		border-radius: 2px;
		padding-left: 50px;
        box-sizing: border-box;
	}
</style>